import { I18n } from '@affine/i18n';
import { QuickToolMixin } from '@blocksuite/affine-widget-edgeless-toolbar';
import { SignalWatcher } from '@blocksuite/global/lit';
import { DualLinkIcon } from '@blocksuite/icons/lit';
import { css, html, LitElement } from 'lit';

import { AutomationConnectorTool } from '../automation-connector-tool.js';

/**
 * Toolbar button for the Automation Connector Tool.
 *
 * Visibility is controlled by the QuickToolExtension builder (enable flag)
 * based on workflow engine configuration status. This component only handles rendering.
 *
 * Activates the tool for creating edges between Database and Automation blocks.
 * Hotkey: 'W'
 *
 * @see sl-zfd.1 for feature specification
 */
export class AutomationConnectorToolButton extends QuickToolMixin(
  SignalWatcher(LitElement)
) {
  static override styles = css`
    :host {
      display: flex;
    }
  `;

  override type = AutomationConnectorTool;

  override render() {
    const { active } = this;
    const tooltipText = I18n.t(
      'com.streamlain.streamlain.toolbar.automationConnector'
    );

    return html`
      <edgeless-tool-icon-button
        class="automation-connector-button"
        .tooltip=${html`<affine-tooltip-content-with-shortcut
          data-tip="${tooltipText}"
          data-shortcut="${'W'}"
        ></affine-tooltip-content-with-shortcut>`}
        .tooltipOffset=${17}
        .active=${active}
        .iconContainerPadding=${6}
        .iconSize=${'24px'}
        @click=${() => {
          this.setEdgelessTool(this.type);
        }}
      >
        ${DualLinkIcon()}
      </edgeless-tool-icon-button>
    `;
  }
}
